import { useGlobalShortcut } from '@/hooks/useGlobalShortcut';

/**
 * Registers Undo/Redo keyboard shortcuts via the global registry so they show
 * up in the "Keyboard Shortcuts" help dialog (?) and play nicely with any
 * other shortcut a feature wants to ship.
 *
 * Bindings:
 *   Cmd/Ctrl+Z          → undo
 *   Cmd/Ctrl+Shift+Z    → redo
 *   Cmd/Ctrl+Y          → redo (Windows convention)
 */
export function useUndoRedoKeyboard(undo, redo) {
  useGlobalShortcut({
    id: 'report-builder.undo',
    keys: 'mod+z',
    label: 'Undo',
    category: 'Editing',
    handler: () => undo?.(),
  });

  useGlobalShortcut({
    id: 'report-builder.redo',
    keys: ['mod+shift+z', 'mod+y'],
    label: 'Redo',
    category: 'Editing',
    handler: () => redo?.(),
  });
}
